// Ladder drill options by phase
export const LADDER_DRILL_OPTIONS = {
  phase_1: [
    'High knees',
    'Forward jumps',
    'Sideways jumps',
    'Forward fast feet (inside in)',
    'Ickey shuffle',
    'In-out forward jumps (one side)',
  ],
  phase_2: [
    'In-out forward jumps (both sides)',
    'Forward hops (continuous, every rung)',
    'Hop scotch',
    'In-out sideways jumps (one side)',
    'Sideways high knees',
    'Sideways running man',
  ],
  phase_3: [
    'In-out forward hops (one side)',
    'In-out sideways hops (outside leg, one side)',
    'In-out sideways hops (inside leg, one side)',
    'In-out sideways jumps (both sides)',
    'Sideways hops (outside leg)',
    'Forward jumps (90° turn)',
    'Sideways 90° hip turn jumps',
    'Forward hop and stick (every other rung)',
    'Lateral bounds',
    'Cross-over step and stick',
  ],
  phase_4: [
    'In-out forward hops (both sides)',
    'In-out sideways hops (outside leg, one side)',
    'In-out sideways hops (inside leg, one side)',
    'Sideways 180° hip turn jumps',
    'Forward carioca',
    'Forward hop and stick (every third rung)',
    'Forward fast feet (outside in)',
    'Ice skaters (for distance)',
  ],
};

// Helper to get ladder drill options for a phase
export function getLadderDrillOptions(phaseNum) {
  return LADDER_DRILL_OPTIONS[`phase_${phaseNum}`] || [];
}